import React, { useState } from 'react';
import { ChevronDown, Info, TrendingUp, TrendingDown, Minus } from 'lucide-react';

const items = [
    {
        label: 'Öneri (LONG / SHORT / BEKLE)',
        icon: <TrendingUp className="h-3.5 w-3.5 text-emerald-400" />,
        desc: 'Net işlem önerisi. Sinyallere göre LONG GİR, SHORT GİR veya BEKLE der. Mevcut fiyattan giriş, hedef ve stop fiyatlarını + olası kâr/zarar yüzdesini + R/R oranını birlikte gösterir. BEKLE: sinyaller zayıf veya risk çok yüksek demektir.',
    },
    {
        label: 'Yön Eğilimi',
        icon: <TrendingUp className="h-3.5 w-3.5 text-emerald-400" />,
        desc: 'Trend, funding, L/S, hacim ve RSI sinyallerini birleştirip yukarı/aşağı eğilimi özetler. Önerinin altında yatan ham sinyalleri gösterir.',
    },
    {
        label: 'Fırsat Skoru',
        icon: <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />,
        desc: 'Momentum, trend yapısı, hacim onayı ve risk seviyesini birleştirir. 70+ güçlü koşullar, 40-70 nötr-pozitif, 40 altı zayıf/riskli.',
    },
    {
        label: 'Risk Skoru',
        icon: <span className="h-1.5 w-1.5 rounded-full bg-rose-500" />,
        desc: 'Volatilite + funding sapması + pozisyon kalabalıklığı. 60+ yüksek risk, 30-60 orta, 30 altı düşük.',
    },
    {
        label: 'R/R (Risk/Reward)',
        icon: <Minus className="h-3.5 w-3.5 text-amber-400" />,
        desc: 'Olası kâr / olası zarar oranı. 1.5+ kabul edilebilir, 2+ iyi, 3+ harika. 1\'in altı zayıf işlem demektir.',
    },
    {
        label: 'Fonlama %',
        icon: <Minus className="h-3.5 w-3.5 text-amber-400" />,
        desc: 'Perpetual funding rate. Pozitif = longlar ödüyor (long kalabalık → düşüş baskısı), negatif = shortlar ödüyor (short kalabalık → yukarı sıkışma potansiyeli). 0.05%+ aşırı sayılır.',
    },
    {
        label: 'L/S Oranı',
        icon: <TrendingDown className="h-3.5 w-3.5 text-rose-400" />,
        desc: 'Long / Short pozisyon oranı. 1 = dengeli. 2.5+ long kalabalık (dump riski), 0.5 altı short kalabalık (squeeze potansiyeli).',
    },
    {
        label: 'Pump / Dump Etiketi',
        icon: <TrendingUp className="h-3.5 w-3.5 text-emerald-400" />,
        desc: 'MEDIUM veya HIGH olasılıksal uyarı. Birden fazla sinyalin (hacim + OI + funding + squeeze) örtüştüğünü gösterir.',
    },
];

export default function LegendCard() {
    const [open, setOpen] = useState(false);
    return (
        <div className="border border-slate-700 bg-slate-800 rounded-md overflow-hidden" data-testid="legend-card">
            <button
                onClick={() => setOpen((v) => !v)}
                data-testid="legend-toggle"
                className="w-full px-5 py-3 flex items-center justify-between hover:bg-slate-700/50 transition-colors"
            >
                <div className="flex items-center gap-2.5">
                    <Info className="h-4 w-4 text-slate-300" />
                    <span className="text-sm font-medium text-slate-100">Metrikler nedir? — hızlı açıklama</span>
                    <span className="text-[10px] uppercase tracking-wider text-slate-400 hidden sm:inline">
                        öneri / long / short / kâr % / r-r
                    </span>
                </div>
                <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>

            {open && (
                <div className="border-t border-slate-700 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-0 divide-y md:divide-y-0 md:divide-x divide-slate-700/50 bg-slate-900/20">
                    {items.map((it) => (
                        <div key={it.label} className="p-4 flex items-start gap-3">
                            <span className="shrink-0 mt-0.5 h-5 w-5 flex items-center justify-center">{it.icon}</span>
                            <div className="min-w-0">
                                <div className="text-xs font-medium text-slate-100 uppercase tracking-wider mb-1">{it.label}</div>
                                <p className="text-[11px] text-slate-300 leading-relaxed">{it.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
